import { computed, Ref, ref }           from '@vue/composition-api';
import { Computed, ComputedWithSetter } from '@/types';

interface UseTooltipVisibility {
  setTooltipVisibility: (isVisible: boolean) => void;
  tooltipVisibility: Computed<boolean>;
  tooltipReference: Ref<HTMLElement | null>;
  tooltipFocusout: (event: FocusEvent) => void;
}

const useTooltipVisibility = (relatedTargetIdList?: Array<string | null>): UseTooltipVisibility => {
  const isTooltipContentVisible: Ref<boolean> = ref(false);
  const tooltipReference: Ref<HTMLElement | null> = ref(null);

  const tooltipVisibility: ComputedWithSetter<boolean> = computed({
    get: (): boolean => isTooltipContentVisible.value,
    set: (value: boolean): void => {
      isTooltipContentVisible.value = value;
    },
  });

  const tooltipFocusout = (event: FocusEvent): void => {
    if (!relatedTargetIdList?.includes((event.relatedTarget as HTMLElement)?.getAttribute('id'))) {
      isTooltipContentVisible.value = false;
    } else {
      (tooltipReference.value as HTMLElement).focus();
    }
  };

  const setTooltipVisibility = (isVisible: boolean): void => {
    tooltipVisibility.value = isVisible;
  };

  return {
    setTooltipVisibility,
    tooltipVisibility,
    tooltipReference,
    tooltipFocusout,
  };
};

export default useTooltipVisibility;
